const modalSchedule = document.getElementById( 'staticBackdrop' );

// Listen to message from child window
window.addEventListener('DOMContentLoaded', () => {
    
    if( modalSchedule )
    {
        // Evento de bootstrap cuando el modal comienza a mostrase.
        // Ejecutara la funcion para emitir mensaje al parent que seria el iframe para que muestre el iframe.
        // $( '#staticBackdrop' ).on( 'show.bs.modal', ( e ) => {
        //     window.parent.postMessage('open-widget', '*');
        //     console.log('Evento mostrar modal dentro iframe', e)
        // })
    
        // Evento de bootstrap cuando el modal comienza a ocultarse.
        // Ejecutara la funcion para emitir mensaje al parent que seria el iframe para que oculte el iframe.
        $( '#staticBackdrop' ).on( 'hide.bs.modal', ( e ) => {
            window.parent.postMessage('close-widget-schedule-appointment', '*');
            // console.log('Evento ocultar modal dentro iframe', e)
        })
    }

    window.addEventListener('message', function (e) {

        // console.log('asasas evento dentro iframe');

        if (e.data == 'open-widget-in-iframe-schedule-appointment') {
    
            if ( !modalSchedule ) return;
    
            $( modalSchedule ).modal( 'show' );
            window.parent.postMessage('open-widget-schedule-appointment', '*');
            window.livewire.emit('pre_mount_check_payments_scheduleAppointment');
            // console.log('Evento mostrar modal dentro iframe', e)
        }
    
        if ( e.data == 'close-widget-in-iframe-schedule-appointment' ) {
    
            if ( !modalSchedule ) return;
    
            $( modalSchedule ).modal( 'hide' );
        }
    
    });

})

// Evento para redireccionar al parent usando las urls que emitan las secciones.
window.addEventListener('receiveUrlRedirectModule', event => {
    window.top.location.href = event.detail.urlRedirect;
})